export const STORAGE_CONFIG = {
  // TODO: Discarded as all App users will loose their sessions and will be
  // forced to login again. Activate when possible.
  // name: '__activo2',
  // driverOrder: ['indexeddb', 'websql', 'localstorage'],
};
